import { Switch } from "@components/ui/switch";
import { endpoint } from "@services/api.services";
import { UseMutateFunction } from "@tanstack/react-query";
import Tooltip from "@ui/external/components/tooltip";
import { showToast } from "@utils/helper/index.helper";
import { useHandleAction } from "@utils/hook/index.hook";
import { useSelectionStore } from "@utils/states/index.state";
import { AxiosResponse } from "axios";
import { useMemo } from "react";
interface CloumnListProps {
  refetch?: () => void;
  toggleActiveStatus: UseMutateFunction<
    AxiosResponse<any, any>,
    Error,
    { id: string | number; IsShow: boolean },
    unknown
  >;
}
const ColumnList = ({ refetch, toggleActiveStatus }: CloumnListProps) => {
  const journeyEndpoint = useMemo(() => endpoint["journey"], []);
  const { clearSelection } = useSelectionStore();
  const { handleAction } = useHandleAction({
    endpoint: journeyEndpoint,
    refetch,
  });
  const columns = useMemo(
    () => [
      {
        name: "ID",
        accessKey: "id",
        cell: (row: any) => (
          <span className="font-semibold text-gray-700">{row?.id}</span>
        ),
        sortable: true,
      },
      {
        name: "Title",
        accessKey: "title",
        cell: (row: any) => (
          <Tooltip description={row.title}>
            <div className="flex justify-start text-gray-800">
              <span className="text-start w-fit max-w-[150px] truncate">
                {row.title}
              </span>
            </div>
          </Tooltip>
        ),
        sortable: true,
      },
      {
        name: "URL",
        accessKey: "url",
        cell: (row: any) => (
          <Tooltip description={`https://skillshikshya.com/${row.url}`}>
            <div
              onClick={() => {
                window.navigator.clipboard.writeText(
                  `https://skillshikshya.com/${row.url}`
                );
                showToast({
                  type: "success",
                  description: "Copied to clipboard",
                  title: "Success",
                });
              }}
              className="flex justify-start text-gray-800"
            >
              <span className="text-start w-fit max-w-[150px] truncate">
                {"https://skillshikshya.com/"}+{row.url}
              </span>
            </div>
          </Tooltip>
        ),
        sortable: true,
      },
      {
        name: "Actions",
        cell: (row: any) => (
          <div className="flex items-center gap-3 cursor-pointer font-[500] select-none">
            <Tooltip description={"Toggle Visibility Status"}>
              <div>
                {" "}
                <Switch
                  checked={row?.is_show}
                  onCheckedChange={() =>
                    toggleActiveStatus({ id: row?.id, IsShow: !row?.is_show })
                  }
                  className="cursor-pointer"
                />
              </div>
            </Tooltip>
            <button
              className="text-[#1DA077] cursor-pointer"
              onClick={() => handleAction({ type: "page-edit", data: row.id })}
              title="Edit"
            >
              Edit
            </button>
            <button
              className="text-[#C33241] cursor-pointer"
              onClick={() => {
                clearSelection();
                handleAction({
                  type: "confirm",
                  data: { type: "delete", id: row.id },
                });
              }}
              title="Delete"
            >
              Delete
            </button>
          </div>
        ),
        sortable: false,
      },
    ],
    [handleAction, clearSelection]
  );

  return columns;
};

export { ColumnList };
